<div class="container-header" [class.collapsed]="isCollapsed">
  <div nz-row class="header" [class.collapsed]="isCollapsed">
    <div nz-dropdown [nzDropdownMenu]="menu"
      class="user-container mobile-hidden" *ngIf="auth.user$ | async as user">
      <nz-avatar nzSize="large" [nzSrc]="user.picture"></nz-avatar>
      <div class="info">
        <span class="name">{{user.name}}</span>
        <span class="title-job">{{user.email}}</span>
      </div>
      <span class="dropdown-icon" nz-icon nzType="down"></span>
    </div>
    <nz-dropdown-menu #menu="nzDropdownMenu">
      <ul nz-menu nzSelectable>
        <li nz-menu-item (click)="onGoToUserProfile()">Configuración de perfil</li>
        <li nz-menu-item nzDanger (click)="onLogout()">Cerrar sesión</li>
      </ul>
    </nz-dropdown-menu>

    <div class="mobile-header">
      <img src="assets/Diazar.svg">
      <span>DIAZAR PM</span>
    </div>

    <div class="mobile-header">
      <nz-avatar *ngIf="auth.user$ | async as user" 
        nz-dropdown [nzDropdownMenu]="mobileMenu" nzTrigger="click"
        nzSize="default" [nzSrc]="user.picture"></nz-avatar>
      <button nz-button nzType="text" (click)="toggle()">
        <span nz-icon nzType="menu"></span>
      </button>
    </div>
    <nz-dropdown-menu #mobileMenu="nzDropdownMenu">
      <ul nz-menu nzSelectable>
        <li nz-menu-item (click)="onGoToUserProfile()">Configuración de perfil</li>
        <li nz-menu-item nzDanger (click)="onLogout()">Cerrar sesión</li>
      </ul>
    </nz-dropdown-menu>
  </div>
</div>
